import React from 'react';
import { BasePublicApi } from '#packages/apilib';
import DeprecationOverlayContainer from './component/deprecationOverlayContainer';

import type { DeprecationOverlayScope } from './scope';

export class DeprecationOverlayApi extends BasePublicApi<DeprecationOverlayScope> {}

export const bootstrap = async (scope: DeprecationOverlayScope) => {
  await scope.editorCoreAPI.hooks.stageIsReadyAndVisible.promise;

  scope.workspace.contributeStageComponent(() => (
    <DeprecationOverlayContainer />
  ));
};
